<template>
  <IconLucideRotateCw />
</template>
